jQuery(document).ready(function ($) {
    const blocks = $('.faq-block');
    const faq_title = blocks.find('[data-faq-title]');
    const tabs_label = blocks.find('[data-tab-label]');
    const tabs_content = blocks.find('[data-tab-content]');

    tabs_label.on('click', (e) => {
        const type = e.target?.dataset?.tabLabel ?? '';

        tabs_label.removeClass('active');
        $(e.target).addClass('active');
        tabs_content.hide();
        tabs_content.filter(`[data-tab-content=${type}]`).show();
    });

    faq_title.on('click', (e) => {
        const target_text = $(e.target).siblings('[data-faq-text]');
        const target_item = $(e.target).closest('[data-faq-item]');
        const is_visible = target_text.is(':visible');

        if (!is_visible) {
            target_text.show(500);
            target_item.addClass('active');
        } else {
            target_text.hide(500);
            target_item.removeClass('active');
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const arrow = document.querySelector('#faq-arrow');

    arrow.addEventListener('click', function () {
        document.querySelector('.item__text').classList.toggle('open');
        arrow.classList.toggle('open');
    });
});
